// extracted by mini-css-extract-plugin
export var cardcontainer = "notsticky-timecard-module--cardcontainer--IG24t";
export var datecontainer = "notsticky-timecard-module--datecontainer--HgwfN";
export var cardcontent = "notsticky-timecard-module--cardcontent--5eebl";
export var cardtitle = "notsticky-timecard-module--cardtitle--YgIS4";
export var cardtext = "notsticky-timecard-module--cardtext--1I1H4";
export var centerGraphic = "notsticky-timecard-module--centerGraphic--lGDg-";
export var sideGraphicRight = "notsticky-timecard-module--sideGraphicRight--F6dBt";
export var sideGraphicLeft = "notsticky-timecard-module--sideGraphicLeft--1+08k";
export var polileg = "notsticky-timecard-module--polileg--qF2H1";
export var viol = "notsticky-timecard-module--viol--9vf1+";
export var action = "notsticky-timecard-module--action--5BP+q";
export var grassroots = "notsticky-timecard-module--grassroots--6sbwr";
export var icon = "notsticky-timecard-module--icon--eUH5v";